module.exports = __webpack_public_path__ + "static/media/brandgen-symbol.95abce95.svg";